// extracted by mini-css-extract-plugin
export var contentBody = "_df-9";
export var headerImage = "_df-2";
export var imageButton = "_df-7";
export var imageButtonIcon = "_df-8";
export var imageHeader = "_df-4";
export var imageHeaderText = "_df-5";
export var imageOverlay = "_df-3";
export var imageTitle = "_df-6";
export var imageWrapper = "_df-1";
export var taskList = "_df-a";
export var widget = "_df-0";